import { api } from "../../gateways/unilabApi";

export async function getApps() {
  return await api.get(`dashboard/apps`);
}

export async function getBackEndBuild() {
  return await api.get(`dashboard/backEndBuild`);
}

export async function getImageMod(img) {
  return await api.get(`dashboard/getImmagine?immagine=${img}`);
}